
/* styles */
require("!!../../node_modules/_extract-text-webpack-plugin@1.0.1@extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/_vue-loader@10.3.0@vue-loader/lib/style-rewriter?id=data-v-3bc52204&scoped=true!../../node_modules/_vue-loader@10.3.0@vue-loader/lib/selector?type=styles&index=0!./Loading.vue")

var Component = require("!../../node_modules/_vue-loader@10.3.0@vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../node_modules/_vue-loader@10.3.0@vue-loader/lib/template-compiler?id=data-v-3bc52204!../../node_modules/_vue-loader@10.3.0@vue-loader/lib/selector?type=template&index=0!./Loading.vue"),
  /* scopeId */
  "data-v-3bc52204",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Loading.vue
// module id = 943
// module chunks = 40